export default {
  LANGSKILL_SPREEKVAARDIGHEID: 'spreekvaardigheid',
  LANGSKILL_LUISTERVAARDIGHEID: 'luistervaardigheid',
  LANGSKILL_SCHRIJFVAARDIGHEID: 'schrijfvaardigheid',
  LANGSKILL_LEESVAARDIGHEID: 'leesvaardigheid'
}
